import { Observable, from } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { KULLANICI } from './KULLANICI';
import { AktifKullaniciBilgisiService } from './aktif-kullanici-bilgisi.service';
import { environment } from '../../../environments/environment';
import { AktifKullaniciBilgisi } from './AktifKullaniciBilgisi';
import { Router } from '@angular/router';
import { SifreHatirlatInfo } from './SifreHatirlatInfo';
import { LoginOzetBilgiInfo } from '@core/models/fatura/LoginOzetBilgiInfo';
import { SifresizLoginInfo } from '@core/models/genel/SifresizLoginInfo';
import { MuhasebeciMaliMusavirGirisInfo } from '@core/models/genel/MuhasebeciMaliMusavirGirisInfo';
import { IslemSonuc } from '@core/models/genel/IslemSonuc';
import { OrtaklikBasvuruFormuInfo } from './OrtaklikBasvuruFormuInfo';
import { BayiGirisInfo } from '@core/models/genel/BayiGirisInfo';
import { MuhasebeciMaliMusavirTelefonlarInfo } from '@core/models/genel/MuhasebeciMaliMusavirTelefonlarInfo';
import { FaturaNumaraSayacInfo } from '@core/models/fatura/FaturaNumaraSayacInfo';
import { SelectedSubeService } from './kullanici-sube-bilgisi.service';

@Injectable()
export class AuthenticationService {


	constructor(private http: HttpClient,
		private router: Router,
		private aktifKullaniciBilgisiService: AktifKullaniciBilgisiService,
		private kullaniciSubeBilgisiService: SelectedSubeService
	) {
	}

	/**
	 * Kullanıcı girişi yapılmış mı kontrol eder.
	 * @description true ya da false değeri dönmeli
	 * @returns {boolean}
	 * @memberOf AuthService
	 */
	public isLoggedIn(): boolean {

		if (this.aktifKullaniciBilgisiService.aktifKullaniciBilgisi && this.aktifKullaniciBilgisiService.aktifKullaniciBilgisi.KLNC_YETKILI_MI) {
			return true;
		} else {
			return false;
		}
	}

	/**
	 * Login isteği gönderir
	 * @param {KULLANICI} credential
	 * @returns {Observable<any>}
	 */
	public login(credential: KULLANICI): Observable<any> {
		return this.http.post<any>(environment.API_KULLANICI_URL + 'loginUI', credential).pipe(
			map((result: any) => {
				if (result instanceof Array) {
					return result.pop();
				}
				return result;
			}),
			tap(this.saveAccessData.bind(this))
			//catchError(this.handleError('login', []))
		);
	}
	public autologin(url: string, ID: number): Observable<any> {

		let dto: sefAutoLoginDto = new sefAutoLoginDto()
		dto.token = url,
			dto.softwareID = ID
		return this.http.post<any>(environment.API_KULLANICI_URL + 'autologin', dto).pipe(
			map((result: any) => {
				if (result instanceof Array) {
					return result.pop();
				}
				return result;
			}),
			tap(this.saveAccessData.bind(this))
			//catchError(this.handleError('login', []))
		);
	}
	public verifyOtpCode(userName: string, code: number) {
		return this.http.get<any>(environment.API_KULLANICI_URL + "checkotpcode/" + userName + "/" + code);
	}

	public changePassword(postData: any) {
		return this.http.post<any>(environment.API_KULLANICI_URL + "changePassword", postData);
	}

	public postSifresizKullaniciGirisKontrol(info: SifresizLoginInfo): Observable<any> {
		return this.http.post<any>(environment.API_KULLANICI_URL + 'sifresizkullanicigiris', info).pipe(
			map((result: any) => {
				if (result instanceof Array) {
					return result.pop();
				}
				return result;
			}),
			tap(this.saveAccessData.bind(this))

		);
	}

	public postSifresizKullaniciGirisKontrolWithEncryptData(info: SifresizLoginInfo): Observable<any> {
		return this.http.post<any>(environment.API_KULLANICI_URL + 'sifresizkullanicigirisWithEncryptData', info).pipe(
			map((result: any) => {
				if (result instanceof Array) {
					return result.pop();
				}
				return result;
			}),
			tap(this.saveAccessData.bind(this))
		);
	}

	getLoginOzetBilgi(loginTipiId: number): Observable<LoginOzetBilgiInfo> {
		return this.http.get<LoginOzetBilgiInfo>(environment.API_KULLANICI_URL + 'loginozetbilgi/' + loginTipiId.toString());
	}

	muhasebeciMaliMusavirGiris(info: MuhasebeciMaliMusavirGirisInfo): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_KULLANICI_URL + 'muhasebecimalimusavirgiris', info);
	}

	muhasebeciMaliMusavirTelefonlariGetir(MUHASEBECI_MALI_MUSAVIR_VKN_TCKN: string, GORMEK_ISTENEN_VKN_TCKN: string): Observable<MuhasebeciMaliMusavirTelefonlarInfo> {
		return this.http.get<MuhasebeciMaliMusavirTelefonlarInfo>(environment.API_KULLANICI_URL + 'muhasebecimalimusavirtelefonlar/' + MUHASEBECI_MALI_MUSAVIR_VKN_TCKN + '/' + GORMEK_ISTENEN_VKN_TCKN);
	}

	muhasebeciMaliMusavirDogrula(info: any): Observable<any> {
		return this.http.post<AktifKullaniciBilgisi>(environment.API_KULLANICI_URL + 'muhasebecimalimusavirdogrula', info).pipe(
			map((result: any) => {
				if (result instanceof Array) {
					return result.pop();
				}
				return result;
			}),
			tap(this.saveAccessData.bind(this))
		);
	}

	muhasebeciMaliMusavirDogrulamaKoduSil(info: any): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_KULLANICI_URL + 'muhasebecimalimusavirdogrulamakodusil', info);
	}

	bayiGiris(info: BayiGirisInfo): Observable<IslemSonuc> {

		return this.http.post<any>(environment.API_KULLANICI_URL + 'bayilogin', info).pipe(
			map((result: any) => {
				if (result instanceof Array) {
					return result.pop();
				}
				return result;
			}),
			tap(this.saveAccessData.bind(this))
		);
	}

	/**
 * Aktif kullanıcıyı yeniler
 */
	public aktifKullaniciBilgisiniYenile() {
		this.http.get<any>(environment.API_KULLANICI_URL + 'kullaniciyenile').subscribe(gelen => {
			this.saveAccessData(gelen);
		});
	}

	/**
	 * Handle Http operation that failed.
	 * Let the app continue.
	 * @param operation - name of the operation that failed
	 * @param result - optional value to return as the observable result
	 */
	private handleError<T>(operation = 'operation', result?: any) {
		return (error: any): Observable<any> => {
			// TODO: send the error to remote logging infrastructure
			console.error(error); // log to console instead

			// Let the app keep running by returning an empty result.
			return from(result);
		};
	}

	/**
	 * Logout
	 */
	public logout(): void {
		this.aktifKullaniciBilgisiService.aktifKullaniciBilgisiniSifirla();
		this.aktifKullaniciBilgisiService.aktifFaturaBilgisiniSifirla();
		this.kullaniciSubeBilgisiService.clearSube();
		this.router!.navigate(['login']);
		setTimeout(function () {
			this.router!.navigate(['login']);
		}, 300);
	}

	/**
	 * Save access data in the storage
	 * @private
	 * @param {AccessData} data
	 */
	private saveAccessData(accessData: any): boolean | void {
		if (typeof accessData !== 'undefined') {
			sessionStorage.setItem('a', accessData.a);
			this.aktifKullaniciBilgisiService.aktifKullaniciBilgisiniDoldur();
			return true;
		}
	}

	/**
	 * Submit registration request
	 * @param {Credential} credential
	 * @returns {Observable<any>}
	 */
	public register(credential: KULLANICI): Observable<any> {
		// dummy token creation
		credential = Object.assign({}, credential, {
			accessToken: 'access-token-' + Math.random(),
			refreshToken: 'access-token-' + Math.random(),
			roles: ['USER'],
		});
		return this.http.post(environment.API_KULLANICI_URL, credential)
			.pipe(catchError(this.handleError('register', []))
			);
	}

	public basvur(info: KULLANICI): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_KULLANICI_URL + "basvur/", info);
	}

	public basvuruTamamla(info: KULLANICI): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_KULLANICI_URL + "basvurutamamla/", info);
	}

	public ortakBuroBasvur(info: OrtaklikBasvuruFormuInfo): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_KULLANICI_URL + "ortakburobasvur/", info);
	}

	public ortakBuroBasvuruTamamla(info: KULLANICI): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_KULLANICI_URL + "ortakburobasvurutamamla/", info);
	}

	/**
	 * Submit forgot password request
	 * @param {SifreHatirlatInfo} credential
	 * @returns {Observable<any>}
	 */
	public requestPassword(credential: SifreHatirlatInfo): Observable<any> {
		return this.http.post<SifreHatirlatInfo>(environment.API_KULLANICI_URL + 'sifrehatirlat', credential).pipe(
			map((result: any) => {
				if (result instanceof Array) {
					return result.pop();
				}
				return result;
			}),
			tap(this.saveAccessData.bind(this))
		);
	}

	yetkisiVarMi(kontrolNoktasi: any) {
		let ret = false;
		if (typeof kontrolNoktasi === 'string') {
			ret = this.yetkiKontrol(kontrolNoktasi);
		} else {
			let kontrolNoktalari: string[] = kontrolNoktasi;
			if (kontrolNoktalari) {
				for (let index = 0; index < kontrolNoktalari.length; index++) {
					ret = this.yetkiKontrol(kontrolNoktalari[index]);
					if (ret) {
						break;
					}
				}
			}
		}
		return ret;
	}

	private yetkiKontrol(kontrolNoktasi: string): boolean {
		let ret = false;
		let auth: AktifKullaniciBilgisi = null;
		// Aktif kullanıcı bilgisini doldur
		auth = this.aktifKullaniciBilgisiService.aktifKullaniciBilgisi;
		if (auth) {
			// Kontrol noktasına erişim var mı kontrol et
			if (kontrolNoktasi.indexOf(':') >= 0) {
				let words: string[] = kontrolNoktasi.split(':');
				kontrolNoktasi = words[0].toLowerCase();
			} else {
				kontrolNoktasi = kontrolNoktasi.toLowerCase();
			}
			// Yetkiyi bul
			ret = auth.KLNC_YETKI_INFO.find(c =>
				c.KONTROL_NOKTASI_ADI.toLowerCase() === kontrolNoktasi) != null;
		}
		return ret;
	}


	public getIP(): Observable<any> {
		return this.http.get<any>(environment.API_KULLANICI_URL + 'kullaniciipgetir');
	}

	buYilPrefixVarMi() {
		return this.http.get<IslemSonuc>(environment.API_FATURALAR_URL + "buyilprefixvarmi");
	}

	topluPrefixEkle(prefixModels: FaturaNumaraSayacInfo[]): Observable<FaturaNumaraSayacInfo[]> {
		return this.http.post<FaturaNumaraSayacInfo[]>(environment.API_FATURA_NUMARA_SAYAC_URL + "topluprefixekle", prefixModels)
	}
}

export class sefAutoLoginDto {
	softwareID: number
	token: string
}
